import React from "react";
import { Nav, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Listener from "./Listener";
import {
  selectEventHandlers,
  selectWorkflowEventListeners,
} from "../../../store/slices/projectSlice";
import HelpButton from "../../../HelpContent/HelpButton";
import { useConfirmDialog } from "../../Components/ConfirmDialogContext";
import MyScroll from "../../../Common/MyScroll";
import {
  faChevronCircleLeft,
  faCircleChevronRight,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";

export default function ListenerTabs({ dispatch }) {
  const navigate = useNavigate();
  const confirmDialog = useConfirmDialog();
  const eventHandlers = useSelector(selectEventHandlers);

  const params = useParams();
  const { event, workflowUUID } = params;

  const eventListeners = useSelector(
    selectWorkflowEventListeners(workflowUUID)
  );

  return (
    <>
      <Tab.Container
        id="listeners-tabs"
        activeKey={params.listenerUUID}
        onSelect={(key) => {
          if (key === "add-listener") {
            dispatch({
              type: "add-listener",
              event,
            });
          } else {
            navigate(
              `/library/logic/builder/${params.projectID}/workflow/${params.workflowUUID}/event/${params.event}/listener/${key}`
            );
          }
        }}
      >
        <Nav variant="tabs" className="row flex-nowrap">
          <div className="col-1">
            <Nav.Item>
              <Nav.Link disabled>
                <span className="fw-bold">
                  {params.event === "form-render" ? "Panels" : "Listeners"}:
                </span>
              </Nav.Link>
            </Nav.Item>
          </div>
          <div className="col-9">
            <MyScroll theme="dark" key={eventListeners}>
              <div className="d-flex flex-nowrap">
                {eventListeners
                  ?.filter((listener) => listener.EventType === event)
                  .sort((a, b) => a.Order - b.Order)
                  .map((listenerState, index, listeners) => (
                    <Nav.Item key={listenerState.UUID}>
                      <Nav.Link
                        key={listenerState.UUID}
                        eventKey={listenerState.UUID}
                        className="text-nowrap"
                      >
                        {
                          // Move to the left button
                          index > 0 && (
                            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                            <span
                              title="Move left"
                              onClick={(e) => {
                                e.stopPropagation();
                                dispatch({
                                  type: "listener-left",
                                  event,
                                  order: listenerState.Order,
                                  listenerId: listenerState.UUID,
                                });
                              }}
                              className="btn py-0 px-1"
                            >
                              <FontAwesomeIcon icon={faChevronCircleLeft} />
                            </span>
                          )
                        }
                        <span
                          title={
                            eventHandlers?.find(
                              (eh) => eh.UUID === listenerState.EventHandlerUUID
                            )?.Label
                          }
                          className="px-1 d-inline-block"
                          style={{ minWidth: "5rem" }}
                        >
                          {eventHandlers
                            .find(
                              (eh) => eh.UUID === listenerState.EventHandlerUUID
                            )
                            ?.Label.slice(0, 10) || "New listener"}
                        </span>
                        {
                          // Move to the right button
                          index < listeners.length - 1 && (
                            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
                            <span
                              type="button"
                              title="Move right"
                              onClick={(e) => {
                                e.stopPropagation();
                                dispatch({
                                  type: "listener-right",
                                  event,
                                  order: listenerState.Order,
                                  listenerId: listenerState.UUID,
                                });
                              }}
                              className="btn py-0 px-1"
                            >
                              <FontAwesomeIcon icon={faCircleChevronRight} />
                            </span>
                          )
                        }
                      </Nav.Link>
                    </Nav.Item>
                  ))}
              </div>
            </MyScroll>
          </div>
          <div className="col-2">
            <Nav.Item>
              <Nav.Link eventKey="add-listener" className="text-nowrap">
                <span>
                  <FontAwesomeIcon icon={faPlusCircle} /> Add{" "}
                  {params.event === "form-render" ? "panel" : "listener"}
                  <HelpButton helpKey="components-add-listener" />
                </span>
              </Nav.Link>
            </Nav.Item>
          </div>
        </Nav>
        <Listener
          setListener={(data) =>
            dispatch({
              type: "update-listener",
              data,
            })
          }
          removeEventListener={(listenerState) => {
            (async () => {
              const ans = await confirmDialog(
                "Delete listener",
                `Are you sure you want to delete this listener?`
              );
              if (ans === false) {
                return;
              }

              dispatch({
                type: "remove-listener",
                listener: listenerState,
                event: listenerState.EventType,
              });
              // navigate to the first listener
              const listenerUUID = eventListeners?.find(
                (l) =>
                  l.EventType === event &&
                  l.Order === 0 &&
                  l.UUID !== listenerState.UUID
              )?.UUID;
              if (listenerUUID) {
                navigate(
                  `/library/logic/builder/${params.projectID}/workflow/${params.workflowUUID}/event/${event}/listener/${listenerUUID}`
                );
              } else {
                navigate(
                  `/library/logic/builder/${params.projectID}/workflow/${params.workflowUUID}/event/${event}`
                );
              }
            })();
          }}
        />
      </Tab.Container>

      {params.listenerUUID &&
        !eventListeners?.find((l) => l.UUID === params.listenerUUID) && (
          <div className="alert alert-warning">Listener not found</div>
        )}
    </>
  );
}
